import { Box, styled } from "@mui/material";

export const BoxTokenizationCertificate = styled(Box)(() => ({
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
  "& .BoxTokenizationCertificate__actions": {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    gap: "16px",
    "& .upload-button": {
      minHeight: "32px",
      height: "32px",
      width: "fit-content",
    },
    "& .file-name:only-child": {
      flex: "1",
      textAlign: "center",
    },
  },
  "& .BoxTokenizationCertificate__buttons": {
    display: "flex",
    gap: "16px",
    marginTop: "32px",
    alignItems: "center",
    justifyContent: "center",
  },
}));
